<template>
    <div>
        <div style="width: 100%;text-align: right;">
            <el-row :gutter="12">
                <el-col :span="2">
                    <el-button type="primary" @click="readyNewProfitSharing">新增分润方案</el-button>
                </el-col>
                <el-col :span="22">
                    <div style="width: 100%;text-align: right;">
                        <el-select v-model="condition.type" clearable>
                            <el-option label="按各自售价梯度分润" value="1" />
                            <el-option label="根据设备所属代理商的类型按百分比分润" value="2" />
                        </el-select>
                        <el-input v-model="condition.name" placeholder="请输入名称" style="width: 200px" clearable />
                        <el-button @click="updateTable()" icon="el-icon-search" style="margin-left: 3px;">搜索</el-button>
                    </div>
                </el-col>
            </el-row>

        </div>
        <div style="margin-top: 15px;">
            <el-table ref="multipleTable"
                      :data="tableData"
                      style="width: 100%"
                      element-loading-text="数据正在加载中"
                      @selection-change="handleSelectionChange"
                      :header-cell-style="headClass"
                      :row-style="rowClass">
                <!--<el-table-column type="selection" width="60"></el-table-column>-->
                <el-table-column prop="name" label="分润方案名称"></el-table-column>
                <el-table-column prop="type" label="分润类型">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.type === 1">按各自售价梯度分润</el-tag>
                        <el-tag type="success" v-if="scope.row.type === 2">按代理商类型百分比分润</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <button @click="getMessage(scope.row)">查看</button>
                        <button @click="deleteProfitSharing(scope.row.sid)">删除</button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination background
                           style="text-align:right;margin-top: 15px;margin-bottom: 55px;"
                           @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="currentPage"
                           :page-sizes="[10, 50, 100, 200]"
                           :page-size="pageSize"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>
            <el-dialog title="新增分润方案" :before-close="handleClose" :visible.sync="isNew" width="620px"
                       :close-on-click-modal="false">
                <el-form :rules="profitSharingFormRules" ref="profitSharingForm" :model="profitSharingForm">
                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="分润方案名称" prop="name">
                                <el-input v-model="profitSharingForm.name" style="width: 240px;" />
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="分润方案类型" prop="type">
                                <el-select v-model="profitSharingForm.type" style="width: 240px;">
                                    <el-option label="按各自售价梯度分润" :value="1" />
                                    <el-option label="按代理商类型百分比分润" :value="2" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row v-if="profitSharingForm.type === 2">
                        <el-col :span="12">
                            <el-form-item label="添加代理商">
                                <el-select v-model="selectId" style="width: 180px;">
                                    <el-option v-for="(agent,i) in allAgentCategory" :label="agent.name" :value="i" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-button type="primary" @click="addAgentToList(selectId)">新增代理商</el-button>
                        </el-col>
                    </el-row>
                    <el-row v-if="profitSharingForm.type === 2">
                        <el-col :span="24">
                            <table style="text-align: center;">
                                <tr
                                    v-if="valueForm.agentCategoryList !== null && valueForm.agentCategoryList.length > 0">
                                    <th>代理商类型</th>
                                    <th>代理商分润占比</th>
                                    <th>操作</th>
                                </tr>
                                <tr v-for="(agent,index) in valueForm.agentCategoryList" style="max-height:35px;">
                                    <td style="width: 100px;">
                                        <el-tag size="medium" type="primary">{{ agent.name }}</el-tag>
                                    </td>
                                    <td style="width: 200px">
                                        <el-form ref="valueForm" :rule="valueFormRules" :model="valueForm">
                                            <el-form-item :prop="`agentCategoryList.${index}.value`"
                                                          :rules="valueFormRules.value">
                                                <el-input size="mini" v-model="agent.value"
                                                          style="width: 200px;margin-top: 20px" />
                                            </el-form-item>
                                        </el-form>
                                    </td>
                                    <td style="width: 80px;">
                                        <el-button size="mini" type="danger" @click="removeAgent(agent)"
                                                   style="margin-top: -2px">移除</el-button>
                                    </td>
                                </tr>
                            </table>
                        </el-col>
                    </el-row>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="handleClose">取 消</el-button>
                    <el-button type="primary" v-if="addProfitSharing" @click="submitNewProfitSharing('add')">新 增
                    </el-button>
                    <el-button type="primary" v-if="updateProfitSharing" @click="submitNewProfitSharing('update')">修 改
                    </el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import axios from "axios";

    export default {
        name: "profitSharing",
        data() {
            var validDecimal = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error('输入不可以为空'));
                }
                setTimeout(() => {
                    if (!Number(value)) {
                        callback(new Error('请输入[0,1]之间的数字'));
                    } else {
                        if (value < 0 || value > 1) {
                            callback(new Error('请输入[0,1]之间的数字'));
                        } else {
                            callback();
                        }
                    }
                }, 100);
            }
            return {
                total: 0,
                currentPage: 1,
                pageSize: 10,
                tableData: [],
                isNew: false,
                addProfitSharing: false,
                updateProfitSharing: false,
                sid: '',
                condition: {
                    type: '',
                    name: '',
                },
                profitSharingForm: {
                    sid: '',
                    name: '',
                    type: '',
                    listJson: '',
                },
                allAgentCategory: [],
                selectId: 0,
                agentCategory: {
                    id: '',
                    name: '',
                    value: '',
                },
                //agentCategoryList:[],
                valueForm: {
                    agentCategoryList: [],
                    value: [],
                },
                profitSharingFormRules: {
                    name: [{
                        trigger: 'blur',
                        required: true,
                        message: '名称不能为空!'
                    }],
                    type: [{
                        trigger: 'change',
                        required: true,
                        message: '请选择分润类型!'
                    }],
                },
                valueFormRules: {
                    value: [{
                        trigger: 'blur',
                        validator: validDecimal
                    }],
                }

            }
        },
        mounted() {
            this.updateTable()
        },
        methods: {
            updateTable() {
                var params = {
                    pageId: this.currentPage,
                    size: this.pageSize,
                    type: this.condition.type,
                    name: this.condition.name,
                };
                const loading = this.$loading({
                    lock: true,
                    text: '获取表格数据中...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                var thiz = this;
                axios.get(this.$store.getters.getApiValue + '/profitSharingScheme/list.do', {
                    params: params
                }).then(function(response) {
                    loading.close();
                    var data = response.data;
                    if (data.status == "200") {
                        thiz.total = data.totalCount;
                        thiz.tableData = data.data;
                    }
                }).catch(function(error) {
                    loading.close();
                    console.log(error);
                });

            },
            getAllAgentCategory() {
                var thiz = this;
                axios.get(this.$store.getters.getApiValue + '/profitSharingScheme/allAgentCategory.do', {}).then(
                    function(response) {
                        var data = response.data;
                        if (data.status == "200") {
                            thiz.allAgentCategory = data.data;
                            console.log(thiz.allAgentCategory)
                        }
                    }).catch(function(error) {
                    console.log(error);
                });
            },
            readyNewProfitSharing() {
                this.getAllAgentCategory();
                this.delAll();
                this.isNew = true;
                this.addProfitSharing = true;
                this.$nextTick(() => {
                    this.$refs['profitSharingForm'].clearValidate() // 只清除清除验证
                });
            },
            delAll() {
                this.profitSharingForm.name = '';
                this.profitSharingForm.type = '';
                this.valueForm.agentCategoryList = [];
                this.selectId = 0;
                this.addProfitSharing = false;
                this.updateProfitSharing = false;
                this.isNew = false;
            },
            getMessage(row) {
                this.isNew = true;
                this.updateProfitSharing = true;
                this.addProfitSharing = false;
                this.getAllAgentCategory();
                this.selectId = 0;
                this.profitSharingForm.sid = row.sid;
                this.profitSharingForm.name = row.name;
                this.profitSharingForm.type = row.type;
                this.valueForm.agentCategoryList = JSON.parse(row.listJson);
                this.$nextTick(() => {
                    this.$refs['profitSharingForm'].clearValidate() // 只清除清除验证
                });
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.updateTable();
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.updateTable();
            },
            addAgentToList(i) {
                let agent = this.allAgentCategory[i];
                /*if (this.agentCategoryList.includes(agent)){
                  this.$message.error('已存在相同的代理商类型');
                  return;
                }*/
                var thiz = this;

                try {
                    this.valueForm.agentCategoryList.forEach(function(x, index, a) {
                        if (x.id === agent.id) {
                            throw new Error("ending"); //报错，就跳出循环
                        }
                    });
                } catch (e) {
                    thiz.$message.error('已存在相同的代理商类型');
                    return;
                }
                this.valueForm.agentCategoryList.push(agent);
                //console.log(this.agentCategoryList)
            },
            removeAgent(agent) {
                var thiz = this;
                this.valueForm.agentCategoryList.forEach(function(x, index, a) {
                    if (x.id === agent.id) {
                        thiz.valueForm.agentCategoryList.splice(index, 1);
                    }
                })
            },
            submitNewProfitSharing(method) {

                if (method === 'add') {
                    var params1 = {
                        name: this.profitSharingForm.name,
                        type: this.profitSharingForm.type,
                        listJson: JSON.stringify(this.valueForm.agentCategoryList)
                    }
                    console.log(params1);
                    var thiz = this;
                    axios.get(this.$store.getters.getApiValue + '/profitSharingScheme/add.do', {
                            params: params1
                        })
                        .then(function(response) {
                            var data = response.data
                            if (data.status == '200') {
                                if (data.data) {
                                    thiz.$message.success('操作成功！')
                                    thiz.isNew = false;
                                    thiz.updateTable()
                                } else {
                                    thiz.$message.success('操作失败！')
                                    thiz.isNew = false;
                                    thiz.updateTable()
                                }
                            } else {
                                thiz.$message.error(data.message)
                            }
                        })
                        .catch(function(error) {
                            console.log(error)
                            thiz.$message.error('系统异常!请与管理员联系!')
                            thiz.isNew = false;
                        })
                } else if (method === 'update') {
                    var params2 = {
                        sid: this.profitSharingForm.sid,
                        name: this.profitSharingForm.name,
                        type: this.profitSharingForm.type,
                        listJson: JSON.stringify(this.valueForm.agentCategoryList)
                    }
                    var thiz = this;
                    axios.get(this.$store.getters.getApiValue + '/profitSharingScheme/update.do', {
                            params: params2
                        })
                        .then(function(response) {
                            var data = response.data
                            if (data.status == '200') {
                                if (data.data) {
                                    thiz.$message.success('操作成功！')
                                    thiz.isNew = false;
                                    thiz.updateTable()
                                } else {
                                    thiz.$message.success('操作失败！')
                                    thiz.isNew = false;
                                    thiz.updateTable()
                                }
                            } else {
                                thiz.$message.error(data.message)
                            }
                        })
                        .catch(function(error) {
                            thiz.$message.error('系统异常!请与管理员联系!')
                            thiz.isNew = false;
                        })
                }
            },
            deleteProfitSharing(id) {
                var thiz = this;
                this.$confirm("确认删除该投放点吗?'")
                    .then(_ => {
                        axios.get(thiz.$store.getters.getApiValue + '/profitSharingScheme/del.do', {
                            params: {
                                sid: id
                            }
                        }).then(response => {
                            var data = response.data;
                            if (data.status == "200") {
                                if (data.data != "" && data.data != null) {
                                    thiz.$message.success("删除成功!");
                                    thiz.updateTable();
                                }
                            } else {
                                thiz.$message.error(data.message);
                            }
                        }).catch(function(error) {
                            thiz.$message.error("系统异常,请与管理员联系!");
                        })
                    }).catch(_ => {});
            },


            handleClose() {
                var thiz = this;
                this.$confirm('关闭后数据将丢失，确认关闭？')
                    .then(_ => {
                        thiz.delAll();
                        done();
                    }).catch(_ => {});
            },
            headClass({
                row,
                rowIndex
            }) {
                if (rowIndex == 0) {
                    return ''
                }
                return ''
            },
            rowClass({
                row,
                rowIndex
            }) {
                if (rowIndex % 2 == 0) {
                    return 'background:#F1F2F7;'
                } else {
                    return 'background:white;'
                }
                return ''
            }
        }
    }
</script>

<style scoped>

</style>